/**
 * skyGradientConfig — pure colour math for the `skyGradient` backplane (PX2).
 * `gradientColors` linearly interpolates N hex colours from `from`→`to` (per RGB
 * channel); the builder draws one full-width strip per colour, top→bottom, so a
 * scene gets a lit sky for its parallax silhouettes to read against. Pure (no Pixi).
 */

/** N hex colours linearly interpolated from `from`→`to`, inclusive. `bands` < 2
 *  is clamped to 2 (a gradient needs both ends). first === from, last === to. */
export function gradientColors(from: number, to: number, bands: number): number[] {
  const n = Math.max(2, Math.floor(bands));
  const fr = (from >> 16) & 0xff, fg = (from >> 8) & 0xff, fb = from & 0xff;
  const tr = (to >> 16) & 0xff, tg = (to >> 8) & 0xff, tb = to & 0xff;
  const out: number[] = [];
  for (let i = 0; i < n; i += 1) {
    const t = i / (n - 1);
    const r = Math.round(fr + (tr - fr) * t);
    const g = Math.round(fg + (tg - fg) * t);
    const b = Math.round(fb + (tb - fb) * t);
    out.push((r << 16) | (g << 8) | b);
  }
  return out;
}
